import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component"
import { ShiftHistoryParams } from "@/routes/(inventory)/branch/_layout/reports/shift-history/-data/model";
import { Loading } from "@/layouts/loading";
import { ListShiftsResponse } from "@/gen/shifts/list_shifts_pb";
import { pharmacyClient } from "@/connect";


export const Route = createFileRoute("/(inventory)/branch/_layout/reports/shift-history/")
    ({
        component: Component,
        validateSearch: ShiftHistoryParams,
    });
